module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAUCAYAAACEYr13AAAAa0lEQVQ4EaXBsQ3AMAzAMOn/o12NRicDIeWRPJKfCQeGyM+EA0PkZ8KBIfIz4cAQOZqwGCJHExZD5GjCYogcTVgMkaMJiyFyNGExRI4mLIbI0YTFEDmasBgiRxMWQ+RowmKIHE1YDJFH8ugDvlVAFV+I6zsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/flappybird/number_score_07.png
// module id = 240
// module chunks = 0